import { Connection } from '@/utils';

export class FileService {
    private api: Connection = new Connection();

    public async getUserHandbook(): Promise<any> {
        return (await this.api.get('file/msptHandBook')).data.result;
    }
}
